import { RootState } from "../../reducers";
import { useSelector } from "react-redux";
import FixtureDisplay from "../../components/FixtureDisplay";
import ResultsKey from "../../components/ResultsKey";
import { Event } from "../../types/fixture";
import { marketDataType } from "../../types/marketFilter";
import {
  UnLicensedMessage,
  StatsPerformPanel,
  StatsPerformText,
  WarningMessage,
  StatsPerformPanelLogo,
} from "./styles";
import { convertNameForStatsPerform, getCompetitionName, showTypeName } from "../../utils";
import StatsPerformLogo from "../../assets/stats_perform_logo.png";

interface Props {
  loading: boolean;
  data: Event[];
}

const Results = ({ loading, data }: Props) => {
  const filterStore = useSelector((state: RootState) => state.filter);

  const renderStatsPerform = (market: string) => {
    const typeName = showTypeName(filterStore.market, [
      ...filterStore.configData.markets,
      ...filterStore.configData.playerMarkets[getCompetitionName(filterStore)],
    ]);
    switch (market) {
      case "ML":
        return (
          <div>
            (%) = Team has <b>Won</b>
          </div>
        );
      case "SPREAD":
        return (
          <div>
            (%) = Team has covered the <b>{typeName}</b>
          </div>
        );
      case "TOTAL":
        return (
          <div>
            (%) = Team has gone over the <b>{typeName}</b>
          </div>
        );
      case "FTS":
      case "ATS":
      case "FBS":
        return (
          <div>
            (%) = Player has scored the <b>{convertNameForStatsPerform(typeName)}</b>
          </div>
        );
      case "PDD":
      case "PTDD":
        return (
          <div>
            (%) = Player has scored a <b>{convertNameForStatsPerform(typeName)}</b>
          </div>
        );
      default:
        return (
          <div>
            (%) = Player beat the displayed <b>{convertNameForStatsPerform(typeName)}</b>
          </div>
        );
    }
  };

  const renderStatsPerformPanel = () => {
    const marketTypes = filterStore.configData.markets.map(
      (i: marketDataType) => i.type
    );
    if (!loading && data.length > 0) {
      return (
        <>
          <StatsPerformPanel>
            <div>
              <StatsPerformPanelLogo
                src={StatsPerformLogo}
                alt="Stats Perform Logo"
              />
            </div>
            <StatsPerformText>
              {renderStatsPerform(filterStore.market)}
            </StatsPerformText>
          </StatsPerformPanel>
          {marketTypes.includes(filterStore.market) && <ResultsKey />}
        </>
      );
    }
  };

  const renderUnLicensedMessage = () => {
    if (!filterStore.isLicensed) {
      return (
        <UnLicensedMessage>
          There are no bookmakers offering odds in your state. The odds below
          have been taken from bet365 NJ as a guide.
        </UnLicensedMessage>
      );
    }
  };

  const renderResults = () => {
    if (!loading) {
      if (data.length > 0) {
        return (
          <div>
            {data.map((event, index) => (
              <FixtureDisplay key={`${event.id}-${index}`} event={event} />
            ))}
          </div>
        );
      }
      return <WarningMessage>No Picks Available</WarningMessage>;
    }
  };

  return (
    <>
      {renderStatsPerformPanel()}
      {renderUnLicensedMessage()}
      {renderResults()}
    </>
  );
};

export default Results;
